import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from 'services/Auth';

class WebQrsApi extends Api {
  constructor() {
    super('website/web_qrs/');
  }

  // GET all QR codes with filters
  list = (params = {}) => {
    return this.buildQuery('get', { params });
  };

  // GET one QR code by ID
  show = (id) => {
    return this.buildQuery('get', {}, id);
  };

  // Create new QR code
  create = (data) => {
    return this.buildQuery('post', { data });
  };

  // Update QR code
  update = (id, data) => {
    return this.buildQuery('put', { data }, id);
  };

  // Delete QR code
  delete = (id) => {
    return this.buildQuery('delete', {}, id);
  };

  getFilters = () => {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/filters`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
    });
  };
}

export default new WebQrsApi();
